
.SuggestionChips {
    padding: .5rem 0;

    & .__list {
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        gap: 0.25rem;

        > li {
            list-style: none;
            margin: 0;
            padding: 0;
        }

        :global(.MuiChip-root) {
            border-radius: 4px;
        }

        :global(.MuiChip-label) {
            font-size: 0.7rem;
            padding: 0 4px;
        }
    }

}
